var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 3.33334H15C15.442 3.33334 15.8659 3.50894 16.1785 3.8215C16.4911 4.13406 16.6666 4.55798 16.6666 5.00001V16.6667C16.6666 17.1087 16.4911 17.5326 16.1785 17.8452C15.8659 18.1577 15.442 18.3333 15 18.3333H4.99998C4.55795 18.3333 4.13403 18.1577 3.82147 17.8452C3.50891 17.5326 3.33331 17.1087 3.33331 16.6667V5.00001C3.33331 4.55798 3.50891 4.13406 3.82147 3.8215C4.13403 3.50894 4.55795 3.33334 4.99998 3.33334H6.66665",
    stroke: "#808191",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 1.66666H7.50002C7.03978 1.66666 6.66669 2.03975 6.66669 2.49999V4.16666C6.66669 4.62689 7.03978 4.99999 7.50002 4.99999H12.5C12.9603 4.99999 13.3334 4.62689 13.3334 4.16666V2.49999C13.3334 2.03975 12.9603 1.66666 12.5 1.66666Z",
    stroke: "#808191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/clipboard.2e576207b9aea25b9633092b6da20d95.svg";
export { ForwardRef as ReactComponent };